import React from 'react';

import AnalysisContainer from '@totem/components/surveyV2/analysis/AnalysisContainer';
import AnalysisFilters from '@totem/components/surveyV2/analysis/AnalysisFilters';
import AnalysisTable from '@totem/components/surveyV2/analysis/AnalysisTable';
import OverviewSection from '@totem/components/surveyV2/analysis/OverviewSection';
import IBCard from '@totem/components/ui_components/antDesignOverrides/IBCard';
import ContentLayout from '@totem/components/ui_components/page/ContentLayout';

import '../survey.css';

const styles = {
  title: {
    fontWeight: 700,
    padding: '2rem',
  },
};

const AnalysisPage = () => {
  return (
    <ContentLayout>
      <AnalysisContainer>
        <IBCard isCovered title={'Analysis Report'}>
          <AnalysisFilters />
          <div style={styles.title} styleName="title">
            Overview
          </div>
          <OverviewSection />
          <div style={styles.title} styleName="title middle">
            Policies
          </div>
          <AnalysisTable />
        </IBCard>
      </AnalysisContainer>
    </ContentLayout>
  );
};

export default AnalysisPage;
